module.exports = __webpack_public_path__ + "static/Maytronics_LghtBLUE-4b9b1b04994a8005f9969cbbb3bcd59c.svg";